import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import CaveatCyrillic from "./Caveat-Regular-Cyrillic.woff2";
import CaveatLatinExt from "./Caveat-Regular-LatinExt.woff2";
import CaveatLatin from "./Caveat-Regular-Latin.woff2";

export const CaveatFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: CaveatCyrillic,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.CYRILIC },
  },
  {
    uri: CaveatLatinExt,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT },
  },
  {
    uri: CaveatLatin,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN },
  },
];
